import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { IdProofsController } from './id-proofs.controller';
import { IdProofsService } from './id-proofs.service';
import { IdProofTypes } from './id-proofs-type.entity';
import { IdProofTypesAdapter } from './dto/id-proof-types.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
    imports: [
        TypeOrmModule.forFeature([IdProofTypes]),
      ],
  controllers: [IdProofsController],
  providers: [IdProofsService,IdProofTypesAdapter,ApplicationExceptionHandler,LogsService]
})
export class IdProofsModule {}






